<template>
  <div>
    <section class="content-header">
      <h1>
        Dashboard
        <small>Control panel</small>
      </h1>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#"> <i class="fa fa-dashboard"></i> Home </a>
        </li>
        <li class="breadcrumb-item active">Dashboard</li>
      </ol>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-12">
          <div class="box box-inverse box-dark">
            <div class="box-body">
              <div class="tradingview-widget-container">
                <div
                  class="tradingview-widget-container__widget"
                  id="tradingview-chart"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-12">
          <div class="row">
            <div class="col-lg-12 col-12">
              <wallet></wallet>
              <!-- RANK ICON -->

              <div class="box" v-if="$store.getters.currentUser.rank != 'regular'">
                <div class="box-body text-center">
                  <div>
                    <img
                      :src="$store.getters.currentUser.rank_icon"
                      alt=""
                      style="max-width: 13rem"
                    />
                    <h3 class="mt-2 text-pink">
                      {{ $store.getters.currentUser.rank }}
                    </h3>
                  </div>
                </div>
              </div>
              <account-progress></account-progress>
            </div>
          </div>
        </div>
        <div class="col-lg-8 col-12">
          <div class="row">
            <div class="col-12 col-md-6">
              <swap-leg></swap-leg>
            </div>

            <div class="col-12 col-md-6">
              <span class="box box-solid bg-dark">
                <div class="box-header no-border">
                  <h3 class="box-title">
                    <i data-v-0c23a9bc="" class="mdi mdi-source-branch"></i>
                    Binary to Pay
                  </h3>
                </div>
                <div class="box-body bg-dark">
                  <div class="d-flex flex-column align-items-center">
                    <p class="font-size-40 text-white">
                      <strong>
                        <span>{{ $store.getters.currentUser.binary_to_pay || 0 }}% </span>
                      </strong>
                    </p>
                  </div>
                </div>
              </span>
            </div>

            <div class="col-12 col-md-4">
              <span class="box box-solid bg-dark">
                <div class="box-header no-border">
                  <h4 class="box-title">
                    <i data-v-0c23a9bc="" class="mdi mdi-speedometer"></i>
                    Direct Line Points
                  </h4>
                </div>
                <div class="box-body bg-dark">
                  <div class="d-flex flex-column align-items-center">
                    <p class="font-size-40 text-white">
                      <strong>
                        <span>{{ $store.getters.currentUser.point.direct_line_points || 0 }} </span>
                      </strong>
                    </p>
                  </div>
                </div>
              </span>
            </div>

            <div class="col-12 col-md-4">
              <span class="box box-solid bg-dark">
                <div class="box-header no-border">
                  <h4 class="box-title">
                    <i data-v-0c23a9bc="" class="mdi mdi-steering"></i>
                    Strong Branch Points
                  </h4>
                </div>
                <div class="box-body bg-dark">
                  <div class="d-flex flex-column align-items-center">
                    <p class="font-size-40 text-white">
                      <strong>
                        <span>{{ $store.getters.currentUser.point.binary_strong_points || 0 }} </span>
                      </strong>
                    </p>
                  </div>
                </div>
              </span>
            </div>

            <div class="col-12 col-md-4">
              <span class="box box-solid bg-dark">
                <div class="box-header no-border">
                  <h4 class="box-title">
                    <i data-v-0c23a9bc="" class="mdi mdi-steering"></i>
                    Weak Branch Points
                  </h4>
                </div>
                <div class="box-body bg-dark">
                  <div class="d-flex flex-column align-items-center">
                    <p class="font-size-40 text-white">
                      <strong>
                        <span>{{ $store.getters.currentUser.point.binary_weak_points || 0 }} </span>
                      </strong>
                    </p>
                  </div>
                </div>
              </span>
            </div>
          </div>

          <div class="box">
            <div class="box-header with-border">
              <h3 class="box-title">Crypto Market</h3>
            </div>
            <div class="box-body">
              <div id="crypto-id" style="height: 700px"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <promo-modal></promo-modal>
  </div>
</template>

<script>
import SwapLeg from "@/components/SwapLeg";
import AccountProgress from "@/components/AccountProgress";
import PromoModal from "@/components/PromoModal";
import Wallet from "@/components/Wallet";

export default {
  name: "Home",

  components: { SwapLeg, AccountProgress, PromoModal, Wallet },
  mounted() {
    this.cryptoNews();
    this.stockMarket();
  },
  methods: {
    cryptoNews() {
      var baseUrl = "https://widgets.cryptocompare.com/";
      var scripts = document.getElementById("crypto-id");
      (function () {
        var appName = encodeURIComponent(window.location.hostname);
        if (appName == "") {
          appName = "local";
        }
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        var theUrl = baseUrl + "serve/v1/coin/feed?fsym=BTC&tsym=USD";
        s.src = theUrl + (theUrl.indexOf("?") >= 0 ? "&" : "?") + "app=" + appName;
        scripts.appendChild(s);
      })();
    },
    currencyPairs() {
      let text2 = {
        width: "100%",
        height: 700,
        defaultColumn: "overview",
        defaultScreen: "most_capitalized",
        market: "america",
        showToolbar: true,
        colorTheme: "dark",
        locale: "en",
        isTransparent: true,
      };
      var node = document.createElement("script"); // Create a <li> node
      node.innerText = JSON.stringify(text2);
      node.async = true;
      node.src = "https://s3.tradingview.com/external-embedding/embed-widget-screener.js";

      document.getElementById("crypto-id").appendChild(node);
    },
    stockMarket() {
      let text2 = {
        symbols: [
          {
            title: "BTC/USD",
            proName: "BINANCE:BTCUSDT",
          },
          {
            title: "ETH/USD",
            proName: "BINANCE:ETHUSDT",
          },
          {
            title: "BNB/USD",
            proName: "BINANCE:BNBUSDT",
          },
          {
            title: "XRP/USD",
            proName: "BINANCE:XRPUSDT",
          },
          {
            title: "ADA/USD",
            proName: "BINANCE:ADAUSDT",
          },
          {
            description: "DOT/USD",
            proName: "BINANCE:DOTUSDT",
          },
        ],
        colorTheme: "dark",
        isTransparent: true,
        locale: "en",
      };
      var node = document.createElement("script"); // Create a <li> node
      node.innerText = JSON.stringify(text2);
      node.async = true;
      node.src = "https://s3.tradingview.com/external-embedding/embed-widget-tickers.js";

      document.getElementById("tradingview-chart").appendChild(node);
    },
  },
};
</script>
